import { Navigate } from 'react-router';
import { useActor } from '../../lib/capabilities.js';

/**
 * `/portal` itself renders nothing — it forwards to the right portal.
 *
 * A single "portal home" that branched on actor type inside the component would put
 * an owner's screen and a tenant's screen one boolean apart, and that boolean is
 * exactly the thing you do not want to get wrong. Separate URLs mean separate trees,
 * and a wrong turn lands on a page whose queries return nothing rather than on a page
 * assembled from the wrong half of a ternary.
 */
export function PortalHome() {
  const actor = useActor();
  if (!actor) return null;
  // An applicant reaching /portal (a stale link, or LoginPage's
  // "Continue" button after already being signed in) is not a third portal
  // branch to add here — /apply is its own tree with its own guard (see
  // RequireApplicant), not a RequirePortalActor branch, so this redirect is
  // what keeps that case from bouncing between /portal and /portal/tenant
  // forever instead of a silent infinite loop.
  if (actor.actorType === 'APPLICANT') return <Navigate to="/apply" replace />;
  if (actor.actorType === 'VENDOR') return <Navigate to="/portal/vendor" replace />;
  return <Navigate to={actor.actorType === 'OWNER' ? '/portal/owner' : '/portal/tenant'} replace />;
}
